import Vue from "vue"; // <-- notice the changed import
import axios, { AxiosRequestConfig, AxiosPromise, AxiosError, AxiosResponse } from 'axios';
import { APP_TITLE, API_URL, DCX_URL } from '@/App.settings';
import VueCookies from 'vue-cookies-ts';

Vue.use(VueCookies);

export default class axiosManager extends Vue {
    public post(commandLink: string, datas: any, successCallBack: (result: any) => void) { 

        var jsonDatas = JSON.stringify(datas);

        var data = {
            token: this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "",
            jsonStringData: jsonDatas
        };
        axios({
            method: 'POST',
            url: API_URL + commandLink, 
            data: data
        }).then(response => response.data).then(data => {
            successCallBack(data);
        });
    }

    public async postAwaitable(commandLink: string, datas: any) {
        
        var jsonDatas = datas != null ? JSON.stringify(datas) : null;

        var data = {
            token: this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "",
            jsonStringData: jsonDatas
        };

        const promise = axios({
            method: 'POST',
            url: API_URL + commandLink, 
            data: data
        });

        const AxiosReponse = await promise;
        return AxiosReponse.data;
    }

    public async postAwaitableFile(commandLink: string, datas: any) {

        var jsonDatas = datas != null ? JSON.stringify(datas) : null;

        var data = {
            token: this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "",
            jsonStringData: jsonDatas
        };

        const promise = axios({
            method: 'POST',
            url: API_URL + commandLink,
            data: data,
            responseType: 'blob'
        });

        const AxiosReponse = await promise;
        return AxiosReponse.data;
    }

    //public async postAwaitableFile(commandLink: string, datas: any, file: any) {
    //    var jsonDatas = datas != null ? JSON.stringify(datas) : "";

    //    var data = new FormData();

    //    data.append('token', localStorage.getItem('access_token') != null ? <string>localStorage.getItem('access_token') : "");
    //    data.append("jsonStringData", jsonDatas);
    //    data.append("file", file);

    //    //var data = {
    //    //    token: localStorage.getItem('access_token') != null ? <string>localStorage.getItem('access_token') : "",
    //    //    jsonStringData: jsonDatas
    //    //};

    //    const promise = axios({
    //        method: 'POST',
    //        headers: { 'Content-Type': 'multipart/form-data' },
    //        url: API_URL + commandLink,
    //        data: data
    //    });

    //    const AxiosReponse = await promise;
    //    return AxiosReponse.data;
    //}
}